export function isArrayWithLength(arr) {
   return (Array.isArray(arr) && arr.length)
}

export function getAllowedRoutes(routes) {
   const roles = (localStorage.getItem('role'));
   if (roles === undefined || roles === "")
      return []
   return routes.filter(({ permission }) => {
      if (!permission) return true;
      if (permission.indexOf(roles) !== -1) return true
      else return false
   });
}